<template>
    <div class="single-track-players box">
        <div
            v-if="playerLoading"
            class="new-player-loader"
        >
            <base-loader />
        </div>
        <transition-group
            name="fade"
            mode="out-in"
        >
            <base-loader
                v-if="false === players"
                key="loader"
            />
            <base-listing-handler
                v-else
                key="shows-listing"
                v-slot:default="{
                    filteredItems,
                    pageLimit,
                    itemsCount,
                    totalPages,
                    sortOptions,
                    sortBy,
                    isReverse,
                    controlsChange,
                    paginationShowNav,
                    setPageNumber,
                    pageNum,
                    filters,
                }"
                :items="players"
                :sort-options="controls"
                :paginate="true"
                :page-limit="15"
                :filter-function="featuredFilter"
            >
                <div class="box-title">
                    Single Track Players
                    <div class="filters">
                        <base-checkbox
                            v-for="filter in filterListOptions"
                            :key="filter.type"
                            :values="filters"
                            :value="filter.value"
                            :label="filter.label"
                            :input-class="[`is-${filter.color}`, 'is-small']"
                            @change="value => controlsChange({ filters: value })"
                        />
                        <base-search-input
                            placeholder="Search episode..."
                            @input="value => controlsChange({ searchPhrase: value })"
                        />
                    </div>
                </div>
                <div class="box-content">
                    <div class="player-controls list-control">
                        <base-list-control
                            v-for="option in sortOptions"
                            :key="option.title"
                            :config="option"
                            :sort-by="sortBy"
                            :is-reverse="isReverse"
                            @change="value => controlsChange(value)"
                        />
                    </div>
                    <p v-if="0 === players.length || 0 === filteredItems.length">
                        No players to display
                    </p>
                    <ul
                        v-else
                        class="players-list list"
                    >
                        <single-track-player
                            v-for="player in filteredItems"
                            :key="player.id"
                            :player="player"
                            :show="show"
                            @open-embed="value => openEmbed(value)"
                            @edit-player="value => editPlayer(value)"
                        />
                    </ul>
                    <paginate
                        v-if="itemsCount > pageLimit"
                        :value="pageNum"
                        :page-count="totalPages"
                        :click-handler="setPageNumber"
                        :prev-text="''"
                        :next-text="''"
                        :class="[{ 'has-navigation': paginationShowNav } ,'pagination']"
                        :active-class="'is-active'"
                        :prev-link-class="'pagination-arrow pagination-prev'"
                        :next-link-class="'pagination-arrow pagination-next'"
                        :hide-prev-next="paginationShowNav"
                        :first-last-button="paginationShowNav"
                        :first-button-text="''"
                        :last-button-text="''"
                        :break-view-class="'pagination-decorator'"
                    />
                </div>
            </base-listing-handler>
        </transition-group>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import SingleTrackPlayer from './SingleTrackPlayer';
import { featuredFilter } from '@/utils/listFilters';
import toasts from '@/mixins/toasts';

export default {
    components: {
        Paginate,
        SingleTrackPlayer,
    },

    mixins: [toasts],

    props: {
        players: {
            type: [Array, Boolean],
            default: () => [],
        },
        show: {
            type: Object,
            required: true,
        },
        playerLoading: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        controls: [
            {
                listLabel: 'No.',
                value: 'trackNo',
                iteratees: [
                    item => parseInt(item.trackNo.split(':')[0]),
                    item => parseInt(item.trackNo.split(':')[1]),
                ],
                isReverse: true,
            },
            {
                listLabel: 'Episode Title',
                value: 'title',
            },
        ],
        filterListOptions: [
            {
                value: 'featured',
                label: 'Featured',
                color: 'yellow',
            },
        ],
    }),

    methods: {
        featuredFilter,

        /**
         * Opens track modal
         *
         * @param   {object}  track    Track data
         */
        editPlayer(track) {
            this.$emit('click', {
                editPlayerType: 'track',
                track,
            });
        },

        /**
         * Opens embed
         *
         * @param   {object}  track    Track data
         */
        openEmbed(track) {
            this.$emit('click', {
                editPlayerType: 'track',
                showEmbed: true,
                track,
            });
        },
    },
};
</script>
